import { Box } from '@interstate/components/Box';
import { Typography } from '@interstate/components/Typography';
import { rem } from 'polished';
import styled from 'styled-components';

export const StyledGridCard = styled(Box)`
    && {
        background: ${({ theme }) => theme.tokens.ColorBackgroundDefault};
        border: ${rem(1)} solid ${({ theme }) => theme.tokens.ColorNeutral50};
        border-radius: ${rem(4)};
        padding: ${rem(20)} ${rem(12)};
        display: flex;
        flex-direction: column;
        gap: ${rem(16)};
        width: 100%;
        box-sizing: border-box;
        overflow: hidden;
    }
`;

export const GridCardHeader = styled(Box)`
    && {
        display: flex;
        align-items: center;
        gap: ${rem(8)};
    }
`;

export const HeaderDivider = styled.div`
    && {
        margin: 0 -${rem(12)};
        height: ${rem(1)};
        background-color: ${({ theme }) => theme.tokens.ColorNeutral50};
    }
`;

export const GridLayout = styled(Box)<{ $columns: number; $rows: number }>`
    && {
        display: grid;
        grid-template-columns: ${rem(88)} repeat(${({ $columns }) => $columns}, 1fr);
        grid-template-rows: auto repeat(${({ $rows }) => $rows}, auto);
        gap: ${rem(8)};
    }
`;

export const HeaderInputCell = styled(Box)`
    && {
        display: flex;
        align-items: center;

        & > * {
            width: 100%;
        }
    }
`;

export const CornerLabel = styled(Box)`
    && {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: ${rem(2)};
    }
`;

export const CornerLabelText = styled(Typography)`
    && {
        color: ${({ theme }) => theme.tokens.ColorOnSurfaceMuted};
        font-family: 'Roboto', sans-serif;
        font-size: ${rem(12)};
        font-style: normal;
        font-weight: 600;
        line-height: 130%;
        letter-spacing: ${rem(0.309)};
        text-transform: uppercase;
    }
`;
export const FullWidthGridItem = styled(Box)<{ $isSelected?: boolean; $isClickable?: boolean; $isDisabled?: boolean }>`
    && {
        width: 100%;
        border-radius: ${rem(4)};
        border: ${rem(1)} solid ${({ theme }) => theme.tokens.ColorNeutral100};
        background: ${({ $isSelected, theme }) => ($isSelected ? theme.tokens.ColorNeutral50 : theme.tokens.BaseColorWhite)};
        box-shadow: 0 ${rem(1)} ${rem(2)} 0 ${({ theme }) => theme.tokens.ColorShadowDefault};
        cursor: ${({ $isClickable, $isSelected }) => ($isClickable || $isSelected ? 'pointer' : 'default')};
        opacity: ${({ $isDisabled, $isSelected }) => ($isDisabled && !$isSelected ? 0.4 : 1)};
        outline: ${({ $isSelected, theme }) =>
            $isSelected ? `${rem(2)} solid ${theme.tokens.SemColorBorderInteractiveSelected}` : 'none'};
        outline-offset: ${({ $isSelected }) => ($isSelected ? `${rem(-2)}` : undefined)};

        &:hover {
            ${({ $isClickable, $isSelected, theme }) =>
                $isClickable || $isSelected ? `box-shadow: 0 ${rem(2)} ${rem(4)} 0 ${theme.tokens.ColorShadowDefault};` : ''}
        }
    }
`;
